export const getStatusColor = (status) => {
  switch (status) {
    case "Sold":
      return "#821410";
    case "Pending":
      return "#672F0D";
    case "Active":
      return "#043E06";
    case "Target":
      return "#023052";
    default:
      return "#3E464F";
  }
};

export const getStatusBackgroundColor = (status) => {
  switch (status) {
    case "Sold":
      return "#ffeded";
    case "Pending":
      return "#FFF8E5";
    case "Active":
      return "#f4fff5";
    case "Target":
      return "#E9F5FF";
    default:
      return "#edf1f4";
  }
};

export const priceFormattingOptions = {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
};

export const zIndex = {
  modalControl: 1,
  mapPin: "1 !important",
  modalBottomBar: 2,
  mapPinHover: "3 !important",
  listingGridFilters: 1000,
  overlay: 1500,
  dropdown: 2000,
  searchControls: 2000,
  header: 3000,
  tooltip: 8000,
  stickyHeader: 8500,
  loading: 9000,
  modal: 9999,
};

export async function loadScript(src: string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.addEventListener("load", () => {
      resolve();
    });
    script.addEventListener("error", () => {
      reject(new Error("Could not load script"));
    });
    document && document.body && document.body.appendChild(script);
  });
}
